import { senders } from "./dropdownOptions";
import { initialFormData } from "./formikFields";
import { getLocalDateTimeString } from "./localDateTime";

const makeFormikObj = (shipment, isReturn) => {
    const shipper = senders.find((s) => s.id === shipment.FedEx_ShipperID);
    const commodities = JSON.parse(shipment.FedEx_Commodities);
    const specialServices = shipment.FedEx_SpecialServices ? JSON.parse(shipment.FedEx_SpecialServices) : []; // need ternary here, used to delete original special services array on form submission
    const shipAlert = JSON.parse(shipment.FedEx_ShipAlert);
    const mpsPackages = JSON.parse(shipment.FedEx_MPS);

    let obj = {
        // Recipient information
        includeReturnLabel: shipment.includeReturnLabel,
        isReturnOnly: isReturn,
        country: shipment.ShipToCountry,
        contactName: shipment.ShipToName,
        companyName: shipment.ShipToCompany,
        address1: shipment.ShipToAddrLine1,
        address2: shipment.ShipToAddrLine2,
        address3: shipment.ShipToAddrLine3,
        postalCode: shipment.ShipToZipCode,
        stateProvince: shipment.ShipToState,
        city: shipment.ShipToCity,
        telephone: shipment.ShipToPhone,
        email: shipment.ShipToEmail,
        ext: shipment.ShipToPhoneExtension,
        taxIdType: 'EIN', // might want to add these two tax fields to Aptify
        taxId: '',
        residentialAddress: shipment.isResidentialAddress,
        // Sender information
        shipper: shipper.id,
        shipperName: shipper.contactName,
        shipperTelephone: shipper.telephone,
        shipperEmail: shipper.email,
        shipperCountry: shipper.country,
        shipperAddress1: shipper.address1,
        shipperAddress2: shipper.address2,
        shipperCity: shipper.city,
        shipperState: shipper.state,
        shipperPostalCode: shipper.postalCode,
        shipperCompany: shipper.companyName,
        shipperResidentialAddress: shipper.residential,
        // Package and shipment details
        packageContains: shipment.FedEx_PackageContains,
        numPackages: shipment.numPackages,
        weight: shipment.FedEx_Weight,
        weightUnit: shipment.FedEx_WeightUnit,
        serviceType: shipment.FedEx_ServiceType,
        packageType: shipment.FedEx_PackageType,
        length: shipment.length,
        width: shipment.width,
        height: shipment.height,
        shipDate: getLocalDateTimeString().slice(0, 10),
        declaredValue: shipment.FedEx_DeclaredValue,
        declaredValueCurrency: shipment.FedEx_DeclaredCurrency,
        // Billing details
        billTransportationTo: shipment.FedEx_BillTransportationTo,
        accountNum: shipment.FedEx_BillAccountNo,
        senderAccountNum: process.env.REACT_APP_ACCOUNT_NUM,
        departmentNotesCode: shipment.FedEx_DepartmentNotesCode,
        departmentNotesName: shipment.FedEx_DepartmentNotesName,
        customerReference: shipment.FedEx_DepartmentNotesName,
        poNum: shipment.FedEx_PoNum,
        // Additional references
        invoiceNum: shipment.FedEx_InvoiceNum,
        deliveryInstructions: shipment.FedEx_DeliveryInstructions,
        // Special Services
        specialServices: specialServices,
        // Commodities
        commodities: commodities,
        // Signature options
        signatureOption: shipment.FedEx_SignatureOption,
        // ShipAlert
        shipAlerts: shipAlert,
        // MPS
        mpsPackages: mpsPackages,
        // Customs
        shipmentPurpose: shipment.shipmentPurpose,
        electronicallyUploadTradeDocs: shipment.electronicallyUploadTradeDocs,
        includeCommercialInvoicePf: shipment.includeCommercialInvoice,
        commercialInvoicePfSource: shipment.commercialInvoiceSource,
        includeCertOfOrigin: shipment.includeCertOfOrigin,
        certOfOriginSource: shipment.certOfOriginSource,
        includeEei: shipment.includeEei,
        eeiSource: shipment.eeiSource,
        ftrExemption: shipment.ftrExemption
    }
    if (shipment.FedEx_IsReturn) {
        const returnVals = {
            returnLabelType: shipment.returnType,
            emailLabelTo: shipment.emailLabelTo,
            emailReturnMessage: shipment.emailReturnMessage,
            emailReturnExpirationDate: shipment.emailReturnExpirationDate.slice(0, 10),
            rmaNum: shipment.rmaNum,
            linkToOutbound: shipment.linkedToOutbound,
            returnInstructions: shipment.includeReturnInstructions,
            additionalInstructions: shipment.additionalInstructions,
            readyPickupDateTime: shipment.readyPickupDateTime,
            latestPickupDateTime: shipment.latestPickupDateTime
        }
        obj = { ...obj, ...returnVals };
    }
    return obj;
}

export const repeatShipment = (formik, shipment, associatedReturnShipment) => {
    const formikUpdateValues = makeFormikObj(shipment, shipment.FedEx_IsReturn);
    const { includeReturnLabel, isReturnOnly } = formikUpdateValues;
    const orderNum = shipment.OrderID;
    const replaceNumPackagesValue = formikUpdateValues.mpsPackages.length > formikUpdateValues.numPackages ? true : false;
    if (shipment.FedEx_IsReturn) {
        formik.setValues({
            ...initialFormData,
            includeReturnLabel,
            isReturnOnly,
            replaceNumPackagesValue,
            returnData: {
                ...initialFormData.returnData,
                ...formikUpdateValues
            }
        })
    } else if (shipment.includeReturnLabel && associatedReturnShipment) {
        const formikUpdateReturnValues = makeFormikObj(associatedReturnShipment, false);
        formik.setValues({
            ...initialFormData,
            orderNum,
            replaceNumPackagesValue,
            ...formikUpdateValues,
            returnData: {
                ...initialFormData.returnData,
                ...formikUpdateReturnValues
            }
        })
    } else {
        formik.setValues({
            ...initialFormData,
            orderNum,
            replaceNumPackagesValue,
            ...formikUpdateValues
        })
    }
}

export const createReturn = (formik, shipment) => {
    // TODO - add feature to automatically link this return to the outbound tracking number from the selected shipment
    const formikUpdateValues = makeFormikObj(shipment, true);
    const { includeReturnLabel, isReturnOnly } = formikUpdateValues;
    const replaceNumPackagesValue = formikUpdateValues.mpsPackages.length > formikUpdateValues.numPackages ? true : false;
    formik.setValues({
        ...initialFormData,
        includeReturnLabel,
        isReturnOnly,
        replaceNumPackagesValue,
        returnData: {
            ...initialFormData.returnData,
            ...formikUpdateValues
        }
    })
}
